module.exports = __webpack_public_path__ + "img/w-sales-promotion.19d3a450.svg";